module.exports = __webpack_public_path__ + "static/4-1f6c79a49ad3182f73b52a229af9f6d1.jpg";